import _classCallCheck from "/var/jenkins_home/workspace/ef-website_staging/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/var/jenkins_home/workspace/ef-website_staging/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js";
import _assertThisInitialized from "/var/jenkins_home/workspace/ef-website_staging/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/assertThisInitialized.js";
import _inherits from "/var/jenkins_home/workspace/ef-website_staging/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/var/jenkins_home/workspace/ef-website_staging/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/var/jenkins_home/workspace/ef-website_staging/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/getPrototypeOf.js";
import React from "react";
var __jsx = React.createElement;
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import { Component } from 'react';
import throttle from 'lodash/throttle';
var ScrollAnimation = /*#__PURE__*/function (_Component) {
  _inherits(ScrollAnimation, _Component);
  var _super = _createSuper(ScrollAnimation);
  function ScrollAnimation(props) {
    var _this;
    _classCallCheck(this, ScrollAnimation);
    _this = _super.call(this, props);
    _this.serverSide = typeof window === 'undefined';
    _this.listener = throttle(_this.handleScroll.bind(_assertThisInitialized(_this)), 80);
    _this.visibility = {
      onScreen: false,
      inViewport: false
    };
    _this.state = {
      classes: 'animated',
      style: {
        animationDuration: "".concat(_this.props.duration, "s"),
        opacity: _this.props.initiallyVisible ? 1 : 0
      }
    };
    return _this;
  }
  _createClass(ScrollAnimation, [{
    key: "getElementTop",
    value: function getElementTop(elm) {
      var yPos = 0;
      while (elm && elm.offsetTop !== undefined && elm.clientTop !== undefined) {
        yPos += elm.offsetTop + elm.clientTop;
        elm = elm.offsetParent;
      }
      return yPos;
    }
  }, {
    key: "getScrollPos",
    value: function getScrollPos() {
      if (this.scrollableParent.pageYOffset !== undefined) {
        return this.scrollableParent.pageYOffset;
      }
      return this.scrollableParent.scrollTop;
    }
  }, {
    key: "getScrollableParentHeight",
    value: function getScrollableParentHeight() {
      if (this.scrollableParent.innerHeight !== undefined) {
        return this.scrollableParent.innerHeight;
      }
      return this.scrollableParent.clientHeight;
    }
  }, {
    key: "getViewportTop",
    value: function getViewportTop() {
      // console.log(1111)
      return this.getScrollPos() + this.props.offset;
    }
  }, {
    key: "getViewportBottom",
    value: function getViewportBottom() {
      return this.getScrollPos() + this.getScrollableParentHeight() - this.props.offset;
    }
  }, {
    key: "isInViewport",
    value: function isInViewport(y) {
      return y >= this.getViewportTop() && y <= this.getViewportBottom();
    }
  }, {
    key: "isAboveViewport",
    value: function isAboveViewport(y) {
      return y < this.getViewportTop();
    }
  }, {
    key: "isBelowViewport",
    value: function isBelowViewport(y) {
      return y > this.getViewportBottom();
    }
  }, {
    key: "inViewport",
    value: function inViewport(elementTop, elementBottom) {
      return this.isInViewport(elementTop) || this.isInViewport(elementBottom) || this.isAboveViewport(elementTop) && this.isBelowViewport(elementBottom);
    }
  }, {
    key: "onScreen",
    value: function onScreen(elementTop, elementBottom) {
      return !this.isAboveScreen(elementBottom) && !this.isBelowScreen(elementTop);
    }
  }, {
    key: "isAboveScreen",
    value: function isAboveScreen(y) {
      return y < this.getScrollPos();
    }
  }, {
    key: "isBelowScreen",
    value: function isBelowScreen(y) {
      return y > this.getScrollPos() + this.getScrollableParentHeight();
    }
  }, {
    key: "getVisibility",
    value: function getVisibility() {
      var _this$node;
      var elementTop = this.getElementTop(this.node) - this.getElementTop(this.scrollableParent) - 120;
      var elementBottom = elementTop + ((_this$node = this.node) === null || _this$node === void 0 ? void 0 : _this$node.clientHeight);
      return {
        inViewport: this.inViewport(elementTop, elementBottom),
        onScreen: this.onScreen(elementTop, elementBottom)
      };
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      if (!this.serverSide) {
        var _parentSelector2 = this.props.scrollableParentSelector;
        this.scrollableParent = _parentSelector2 ? document.querySelector(_parentSelector2) : window;
        if (this.scrollableParent && this.scrollableParent.addEventListener) {
          this.scrollableParent.addEventListener('scroll', this.listener);
        } else {}
        if (this.props.animatePreScroll) {
          this.handleScroll();
        }
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      clearTimeout(this.delayedAnimationTimeout);
      clearTimeout(this.callbackTimeout);
      if (window && window.removeEventListener) {
        window.removeEventListener('scroll', this.listener);
      }
    }
  }, {
    key: "visibilityHasChanged",
    value: function visibilityHasChanged(previousVis, currentVis) {
      return previousVis.inViewport !== currentVis.inViewport || previousVis.onScreen !== currentVis.onScreen;
    }
  }, {
    key: "animate",
    value: function animate(animation, callback) {
      var _this2 = this;
      this.delayedAnimationTimeout = setTimeout(function () {
        _this2.animating = true;
        _this2.setState({
          classes: "animated ".concat(animation),
          style: {
            animationDuration: "".concat(_this2.props.duration, "s")
          }
        });
        _this2.callbackTimeout = setTimeout(callback, _this2.props.duration * 1000);
      }, this.props.delay);
    }
  }, {
    key: "animateIn",
    value: function animateIn(callback) {
      var _this3 = this;
      this.animate(this.props.animateIn, function () {
        if (!_this3.props.animateOnce) {
          _this3.setState({
            style: {
              animationDuration: "".concat(_this3.props.duration, "s"),
              opacity: 1
            }
          });
          _this3.animating = false;
        }
        var vis = _this3.getVisibility();
        if (callback) {
          callback(vis);
        }
      });
    }
  }, {
    key: "animateOut",
    value: function animateOut(callback) {
      var _this4 = this;
      this.animate(this.props.animateOut, function () {
        _this4.setState({
          classes: 'animated',
          style: {
            animationDuration: "".concat(_this4.props.duration, "s"),
            opacity: 0
          }
        });
        var vis = _this4.getVisibility();
        if (vis.inViewport && _this4.props.animateIn) {
          _this4.animateIn(_this4.props.afterAnimatedIn);
        } else {
          _this4.animating = false;
        }
        if (callback) {
          callback(vis);
        }
      });
    }
  }, {
    key: "handleScroll",
    value: function handleScroll() {
      if (!this.animating) {
        var _currentVis2 = this.getVisibility();
        if (this.visibilityHasChanged(this.visibility, _currentVis2)) {
          clearTimeout(this.delayedAnimationTimeout);
          if (!_currentVis2.onScreen) {
            this.setState({
              classes: 'animated',
              style: {
                animationDuration: "".concat(this.props.duration, "s"),
                opacity: this.props.initiallyVisible ? 1 : 0
              }
            });
          } else if (_currentVis2.inViewport && this.props.animateIn) {
            this.animateIn(this.props.afterAnimatedIn);
          } else if (_currentVis2.onScreen && this.visibility.inViewport && this.props.animateOut && this.state.style.opacity === 1) {
            this.animateOut(this.props.afterAnimatedOut);
          }
          this.visibility = _currentVis2;
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this5 = this;
      var classes = this.props.className ? "".concat(this.props.className, " ").concat(this.state.classes) : this.state.classes;
      return /*#__PURE__*/React.createElement("div", {
        ref: function ref(node) {
          _this5.node = node;
        },
        className: classes,
        style: Object.assign({}, this.state.style, this.props.style)
      }, this.props.children);
    }
  }]);
  return ScrollAnimation;
}(Component);
ScrollAnimation.displayName = "ScrollAnimation";
export { ScrollAnimation as default };
ScrollAnimation.defaultProps = {
  offset: 150,
  duration: 1,
  initiallyVisible: false,
  delay: 0,
  animateOnce: false,
  animatePreScroll: true
};